import Http from '../http'

// 系统配置API
export default {
  // 参数配置列表
  getConfigList (params) {
    return Http.post('/config/list.do', params)
  },
  // 根据参数名称获取参数信息
  getConfigInfo (params) {
    return Http.post('/config/info.do', params)
  },
  // 根据参数名称修改参数值
  editConfigInfo (params) {
    return Http.post('/config/edit.do', params)
  },
  // 关键字配置列表
  getKeyWordConfigList (params) {
    return Http.post('/keyword/list.do', params)
  },
  // 根据关键字名称获取关键字信息
  getKeyWordConfigInfo (params) {
    return Http.post('/keyword/get.do', params)
  },
  // 根据关键字名称修改关键字值
  editKeyWordConfigInfo (params) {
    return Http.post('/keyword/save.do', params)
  },
  // 添加关键字
  addKeyWord(params) {
    return Http.post('/keyword/add.do', params)
  },
  // 删除关键字
  deleteKeyWord(params) {
    return Http.post('/keyword/delete.do', params)
  },
  // 报警管理列表
  getAlarmManagementList (params) {
    return Http.post('/alarmManagement/list.do', params)
  },
  // 报警管理信息
  getAlarmManagementInfo (params) {
    return Http.post('/alarmManagement/info.do', params)
  },
  // 修改报警管理
  editAlarmManagementInfo (params) {
    return Http.post('/alarmManagement/save.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/systemConfig.js